import React, { useRef, useState } from "react";
import Resizer from "react-image-file-resizer";
import styles from "./ImageLoader.module.scss";
import classNames from "classnames";
import { stringToHslColor } from "../../utils/util";

const ImageLoader = ({
  user,
  textUploadImage,
  flexColumn,
  classNameContainer,
  classNameLogo,
  setImageFile,
  onlyPreview,
}) => {
  const imageInput = useRef();

  const [imagePreview, setImagePreview] = useState(null);

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        200,
        200,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const handleImagePreview = async (e) => {
    if (e.target.files.length !== 0) {
      let image_as_base64 = URL.createObjectURL(e.target.files[0]);
      let image_as_files = e.target.files[0];
      let image = await resizeFile(image_as_files);
      setImagePreview(image_as_base64);
      setImageFile(image);
    }
  };

  const onEditProfilePhotoClick = () => {
    imageInput.current.click();
  };

  return (
    <div
      className={classNames(
        styles.imageLoaderContainer,
        flexColumn && styles.imageLoaderColumn,
        classNameContainer
      )}
    >
      {(user || imagePreview) && (
        <div className={styles.imageLogoContainer}>
          {!user?.profilePhoto && !imagePreview ? (
            <span
              className={classNames(styles.imageLogo, classNameLogo)}
              style={{
                backgroundColor: stringToHslColor(
                  user?.firstName + user?.lastName,
                  40,
                  40
                ),
              }}
            >
              {user?.firstName[0]?.toUpperCase()}
              {user?.lastName[0]?.toUpperCase()}
            </span>
          ) : !imagePreview ? (
            <img
              className={styles.imageLogo}
              src={user?.profilePhoto}
              alt="user_profile_photo"
            />
          ) : (
            <img
              className={styles.imageLogo}
              src={imagePreview}
              alt="avatar_preview"
            />
          )}
        </div>
      )}
      {!onlyPreview && (
        <div>
          <input
            className={styles.imageLogoInput}
            ref={imageInput}
            type="file"
            onChange={handleImagePreview}
          />
          <p className={styles.imageLogoLoad} onClick={onEditProfilePhotoClick}>
            {textUploadImage}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageLoader;
